import { getAuthHeaders } from '../../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

/**
 * Ask the backend to generate (and optionally email) a Calor CDE certificate.
 *
 * Returns { bytes, sha256, filename, emailStatus }.
 * The template never leaves the server; the browser only gets the final
 * flattened PDF.
 */
export const generateCalorCdePdf = async (data, { sendEmail = false, emailTo } = {}) => {
  const payload = { ...data, sendEmail, ...(emailTo ? { emailTo } : {}) };
  const response = await fetch(`${API_URL}/calor/cde-generate`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(true),
      Accept: 'application/pdf',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = `Failed to generate certificate (${response.status})`;
    try {
      const ct = response.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        const body = await response.json();
        if (body?.error) message = body.error;
      }
    } catch (_) {
      // swallow - fall back to default message
    }
    throw new Error(message);
  }

  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  return {
    bytes,
    sha256: response.headers.get('X-CDE-Sha256') || '',
    filename: response.headers.get('X-CDE-Filename') || 'Calor-CDE.pdf',
    emailStatus: response.headers.get('X-CDE-Email-Status') || 'not_sent',
    certificateNumber: response.headers.get('X-CDE-Certificate-Number') || '',
  };
};

export const downloadPdfBlob = (bytes, filename) => {
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export default generateCalorCdePdf;
